export const SCREENER_PAGE_SIZE = 30;
export const SCREENER_HISTORY_PAGE_SIZE = 50;
